import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const barChart: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5-5v4H3v-4Zm3-4v8H6v-8Zm8 9v1H0v-12h1V0Zm-5-7v6H9v-6zm3-3v9h-2v-9zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "16",
  }
};